import React from 'react';

import VoteIcon from '../../icons/VoteIcon';

const colors = require('common/lib/colors/colors.less');
import IconButton from './IconButton';

const VoteButton = (props) => (
  <IconButton {...props} icon={<VoteIcon color={colors.N100} />}>
    Vote
  </IconButton>
);

export default VoteButton;



// WEBPACK FOOTER //
// ./app/common/components/canonical-components/canonical-card/buttons/VoteButton.js